import styled, { css } from 'styled-components'
import * as Navigation from 'components/Sidebar/styles'
import { v } from 'styles/variables.js'

export const Main = styled.main`
  width: ${({ isMenuCollapsed }) => (isMenuCollapsed ? `calc(100vw - 300px)` : `calc(100vw - 107.469px)`)};
  height: 100vh;
  overflow-y: auto;
`

export const Flex = styled.div`
  padding: ${v.xlSpacing};
  max-width: ${({ isManageLiveStream }) => (isManageLiveStream ? null : `${v.flexWidth}`)};

  /* min-width: 100%; */
  display: flex;
  align-items: center;
  margin: 0 auto;
  & > div,
  & > ui {
    flex: 1;
  }
`

// Keep the existing desktop shell; give message editors a full-width mobile workspace.
export const Layout = styled.div`
  display: flex;
  ${({ $messageWorkspace }) =>
    $messageWorkspace &&
    css`
      @media (max-width: 700px) {
        flex-direction: column;
        ${Navigation.Sidebar} {
          width: 100%;
          height: auto;
          padding: 0 12px;
          border-bottom: 1px solid #e5eaf1;
          > * {
            display: none;
          }
          ${Navigation.LinkScroll} {
            display: block;
            height: auto;
            overflow-x: auto;
            > div:first-child {
              display: flex;
              gap: 8px;
            }
            > div:not(:first-child) {
              display: none;
            }
          }
          ${Navigation.StyledLink} {
            white-space: nowrap;
            font-size: 13px;
            padding: 6px 10px;
          }
          ${Navigation.LinkIcon} {
            padding: 6px;
          }
          ${Navigation.LinkContainer} {
            margin: 6px 0;
          }
        }
        ${Main} {
          width: 100%;
          height: calc(100dvh - 59px);
          position: relative;
          padding-top: 82px;
        }
        ${Flex} {
          padding: 12px;
          width: 100%;
          min-width: 0;
          > * {
            min-width: 0;
            width: 100%;
          }
        }
      }
    `}
`
